export class AllocationRequestAccumulationPeriod {
	public year: any;

	constructor(obj) {
		this.year = obj.year;
	}
} 
